import { maskCustomerPhone } from '@/assets/js/customerPhone';

// 엑셀 다운로드시 필요한 함수들

// 날짜 변환 timestamp -> date

function timestampToDate(value) {
    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    return `${new Date(Date.UTC(...b)).getFullYear()}-${addZero(
        new Date(Date.UTC(...b)).getMonth() + 1
    )}-${addZero(new Date(Date.UTC(...b)).getDate())}`;
}

// 날짜 변환시 9 이하의 숫자는 0 붙이기
function addZero(target) {
    const num = parseInt(target);
    const str = num > 9 ? num : `0${num}`;
    return str.toString();
}

// 센터 BizType(업종) 변환
function centerBizType(bizType) {
    let result = '';
    switch (bizType) {
        case 'H': // 헬스장
            result = '헬스장';
            break;
        case 'F': // 필라테스
            result = '필라테스';
            break;
        case 'Y': // 요가
            result = '요가';
            break;
        case 'P': // PT샵
            result = 'PT샵';
            break;
        case 'S': // 스포츠시설
            result = '스포츠시설';
            break;
        case 'B': // 뷰티
            result = '뷰티';
            break;
        case 'E': // 기타
            result = '기타';
            break;
    }
    return result;
}

// 전화번호에 하이픈(-) 추가
function addDashPhoneNumber(phoneNumber) {
    if (!phoneNumber) return phoneNumber;

    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    let tmp = '';
    if (phoneNumber.length < 4) {
        return phoneNumber;
    } else if (phoneNumber.length < 7) {
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3);
        return tmp;
    } else if (phoneNumber.length == 8) {
        tmp += phoneNumber.substr(0, 4);
        tmp += '-';
        tmp += phoneNumber.substr(4);
        return tmp;
    } else if (phoneNumber.length < 10) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-123-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 3);
            tmp += '-';
            tmp += phoneNumber.substr(5);
            return tmp;
        }
    } else if (phoneNumber.length < 11) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-1234-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 4);
            tmp += '-';
            tmp += phoneNumber.substr(6);
            return tmp;
        }
        // 010-123-4567
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3, 3);
        tmp += '-';
        tmp += phoneNumber.substr(6);
        return tmp;
    } else {
        // 010-1234-5678
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3, 4);
        tmp += '-';
        tmp += phoneNumber.substr(7);
        return tmp;
    }
}

// 숫자에 , (콤마) 넣기
function numberFormat(num) {
    if (typeof num !== 'number' || num === undefined || num === '') {
        return num;
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 날짜 필터 yyyymmdd -> yyyy-mm-dd
function dateFormatFilter(stringTypeNumber) {
    // type이 string 이지만 숫자로 이루어졌을 경우만 사용
    if (stringTypeNumber === undefined || stringTypeNumber === '') {
        return numberTypeStr;
    }
    return stringTypeNumber.slice(0, 8).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
}

function phoneNumberFilter(phoneNumber){
    if (!phoneNumber) return phoneNumber || '';

    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    let tmp = '';
    if (phoneNumber.length < 4) {
        return phoneNumber;
    } else if (phoneNumber.length < 7) {
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3);
        return tmp;
    } else if (phoneNumber.length == 8) {
        tmp += phoneNumber.substr(0, 4);
        tmp += '-';
        tmp += phoneNumber.substr(4);
        return tmp;
    } else if (phoneNumber.length < 10) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-123-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 3);
            tmp += '-';
            tmp += phoneNumber.substr(5);
            return tmp;
        }
    } else if (phoneNumber.length < 11) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-1234-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 4);
            tmp += '-';
            tmp += phoneNumber.substr(6);
            return tmp;
        }
        // 010-123-4567
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3, 3);
        tmp += '-';
        tmp += phoneNumber.substr(6);
        return tmp;
    } else {
        // 010-1234-5678
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3, 4);
        tmp += '-';
        tmp += phoneNumber.substr(7);
        return tmp;
    }
}

function excelUpload(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            resolve(new Uint8Array(e.target.result));
        };

        reader.onerror = (e) => {
            reject(e);
        };

        reader.readAsArrayBuffer(file);
    });
}

// 회원 전화번호(엑셀) — 권한이 켜져 있으면 마스킹된 값이 파일에 기록된다.
// 화면만 가리고 엑셀을 열어두면 목록을 통째로 내려받아 우회할 수 있다.
function customerPhoneForExcel(phoneNumber) {
    return maskCustomerPhone(addDashPhoneNumber(phoneNumber));
}

export {
    timestampToDate,
    centerBizType,
    addDashPhoneNumber,
    customerPhoneForExcel,
    numberFormat,
    dateFormatFilter,
    excelUpload,
    phoneNumberFilter,
};
